<template>
    <v-page>
        <v-form v-model="valid" ref="resetPasswordForm" @submit="submitForm">
            <v-card-title primary-title class="pb-4">
                <img src="~@/assets/img/logo.png" alt />
            </v-card-title>
            <v-divider></v-divider>
            <v-text-field
                prepend-icon="fa-user"
                name="username"
                label="Username"
                type="email"
                :rules="emailRules"
                v-model="Email"
                required
                ></v-text-field>

            <v-text-field
                prepend-icon="fa-lock"
                id="password"
                name="password"
                type="password"
                label="Password"
                :rules="[v => !!v || 'Password is required']"
                v-model="Password"
                required
                ></v-text-field>

            <v-text-field
                prepend-icon="fa-lock"
                id="confirmPassword"
                name="confirmPassowrd"
                type="password"
                label="Confirm Password"
                :rules="matchPassword"
                v-model="ConfirmPassword"
                required
                ></v-text-field>
            <v-spacer></v-spacer>
            <v-card-actions style="padding:0px">

                <v-card-title style="padding-bottom: 0px; max-height: 80px;">
                <div>
                    <span class="display-3">{{ appName }}</span>
                    <span class="subheading ml-2">{{ appVersion }}</span>
                </div>
                </v-card-title>


                <v-spacer></v-spacer>
                <v-card-title style="padding-bottom: 0px; padding-top: 40px;">
                <v-btn @click="submitForm" color="primary"
                    :disabled="!valid">Reset Password</v-btn>
                </v-card-title>

            </v-card-actions>
            <v-card-text style="padding-top: 0px;">
                <v-layout row>
                    <v-flex class="ml-1" style="font-size: 12.8px">
                        BILLING &amp; OPERATION SUPPORT SYSTEM
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-form>
    </v-page>
</template>

<script>
import VPage from "../layouts/Minimal.vue";
import Bus from "../bus";
import { App } from "../config.js";
import axios from "axios";

export default {
    name: "ResetPassword",
  components: {
    VPage
  },
  data() {
    return {
      appName: App.name,
      appVersion: App.version,
      valid: true,
      Email: "",
      Password: "",
      ConfirmPassword: "",

      emailRules: [ 
            v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email must be valid'
        ],

      matchPassword: [
          v => (!!v && v) === this.Password || 'Passwords do not match'
        ],
    };
  },

  methods: {
      submitForm(){
          var resetToken = this.$route.query.token;
          console.log(resetToken);
          
          if(this.$refs.resetPasswordForm.validate())
          {
              axios.post('api/User/ResetChangePassword',
                { 
                    "Email": this.Email,
                    "Password": this.Password,
                    "token": resetToken
                })
              .catch(error => {
                
                Bus.$emit("alert", {
                    color: "error",
                    message: error.response.data.Message
                });
                return;
              });
              
              Bus.$emit("alert", {
              color: "success",
              message: "Password reset complete!"
              });

              // redirect to login page
              this.$router.push("/login");
          }
      },
  },

}
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>
